// src/assets/index.js
export * from "./images"; // Export everything from the images folder
export * from "./svg";
